import axios from 'axios';
import { GOOGLE_SPEECH_API_KEY } from '../utils/env';

// Debug environment variables
console.log('Environment variables available:', {
  GOOGLE_SPEECH_API_KEY_EXISTS: !!GOOGLE_SPEECH_API_KEY,
  NODE_ENV: process.env.NODE_ENV,
  ALL_ENV_KEYS: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_'))
});

// Validate API key
if (!GOOGLE_SPEECH_API_KEY) {
  console.error('Google Speech API key is not configured. Available environment variables:', 
    Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
}

export const googleSpeechService = {
  async transcribeAudio(audioBlob) {
    if (!GOOGLE_SPEECH_API_KEY) {
      throw new Error('Google Speech API key is not configured. Please check your environment variables and restart the development server.');
    }

    try {
      // Log API key for debugging (only first few characters)
      console.log('Using API key:', GOOGLE_SPEECH_API_KEY.substring(0, 8) + '...');

      // Convert audio blob to base64
      const base64Audio = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(',')[1]; // Get only the base64 data
          resolve(base64String);
        };
        reader.readAsDataURL(audioBlob);
      });

      // Log audio data size for debugging
      console.log('Audio data size:', base64Audio.length);

      // Prepare the request to Google Speech-to-Text API
      const response = await axios({
        method: 'POST',
        url: `https://speech.googleapis.com/v1p1beta1/speech:recognize?key=${GOOGLE_SPEECH_API_KEY}`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          config: {
            encoding: 'WEBM_OPUS',
            sampleRateHertz: 48000,
            languageCode: 'en-US',
            model: 'default',
            enableAutomaticPunctuation: true,
            useEnhanced: true
          },
          audio: {
            content: base64Audio
          }
        }
      });

      console.log('Google Speech API Response:', response.data); // Debug log

      if (response.data && response.data.results && response.data.results.length > 0) {
        return response.data.results[0].alternatives[0].transcript;
      }

      throw new Error('No transcription results received');
    } catch (error) {
      // Enhanced error logging
      console.error('Detailed transcription error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers,
        config: {
          ...error.config,
          headers: {
            ...error.config?.headers,
            'X-Goog-Api-Key': '***REDACTED***' // Don't log the actual API key
          }
        }
      });

      // More specific error messages
      if (error.response?.status === 403) {
        throw new Error(`Authentication failed: ${error.response?.data?.error?.message || 'Please check your API key and make sure the Speech-to-Text API is enabled in your Google Cloud Console.'}`);
      } else if (error.response?.status === 400) {
        throw new Error(`Invalid request format: ${error.response?.data?.error?.message || 'Please check the audio format.'}`);
      } else {
        throw new Error(
          error.response?.data?.error?.message || 
          'Failed to transcribe audio. Please try again.'
        );
      }
    }
  },
};

export default googleSpeechService; 